export default "__VITE_ASSET__4TWa3nUV__"